import React from 'react';

class LoggerComponent extends React.Component {
  componentDidCatch(e, info) {
    this.props.logger.onError(e, {
      ...info,
      type: 'react'
    });
  }

  render() {
    return this.props.children;
  }
}

export default LoggerComponent;
